import { useEffect, useState } from "react";
import { AlertCircle, CheckCircle2, Info, X, AlertTriangle } from "lucide-react";

import "./vexa-toast.css";

const toneDetails = {
  success: { Icon: CheckCircle2, label: "Listo" },
  error: { Icon: AlertCircle, label: "No se pudo completar" },
  warning: { Icon: AlertTriangle, label: "Revisa este detalle" },
  info: { Icon: Info, label: "Aviso" }
};

export default function VexaToast({ notification, removeNotification }) {
  const [leaving, setLeaving] = useState(false);
  const tone = toneDetails[notification.tone] || toneDetails.info;

  useEffect(() => {
    const timer = window.setTimeout(() => dismiss(), notification.duration || 6500);
    return () => window.clearTimeout(timer);
    // Dismiss belongs to this notice's lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification.id, notification.duration]);

  const dismiss = () => {
    if (leaving) return;
    setLeaving(true);
    window.setTimeout(() => removeNotification(notification.id), 180);
  };

  const { Icon, label } = tone;

  return (
    <article
      aria-live={notification.tone === "error" ? "assertive" : "polite"}
      className={`vexa-toast vexa-toast--${notification.tone || "info"}${leaving ? " is-leaving" : ""}`}
      role={notification.tone === "error" ? "alert" : "status"}
    >
      <div className="vexa-toast__icon"><Icon size={20} strokeWidth={2.1} /></div>
      <div className="vexa-toast__copy">
        <p className="vexa-toast__eyebrow">VexaDent · {label}</p>
        {notification.title && <h3>{notification.title}</h3>}
        <p className="vexa-toast__message">{notification.message}</p>
      </div>
      <button
        aria-label="Cerrar aviso"
        className="vexa-toast__close"
        onClick={dismiss}
        type="button"
      >
        <X size={17} />
      </button>
      <span className="vexa-toast__progress" style={{ animationDuration: `${notification.duration || 6500}ms` }} />
    </article>
  );
}
